import { render } from "./two-factor-modal.vue?vue&type=template&id=26430dd6&scoped=true"
import script from "./two-factor-modal.vue?vue&type=script&lang=js"
export * from "./two-factor-modal.vue?vue&type=script&lang=js"

import "./two-factor-modal.vue?vue&type=style&index=0&id=26430dd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26430dd6"]])

export default __exports__